import { render, staticRenderFns } from "./index.vue?vue&type=template&id=61f20d4a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=61f20d4a&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=61f20d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f20d4a",
  null
  
)

export default component.exports